import React, { useState, useEffect } from 'react';
import { motion } from "framer-motion";
import { Mail } from 'lucide-react'; // 使用 lucide-react 的郵件圖標

function Email() {
    const [email, setEmail] = useState('');
    const [accounts, setAccounts] = useState([]);
    const [messages, setMessages] = useState([]);
    const [selectedAccount, setSelectedAccount] = useState(null);
    const [selectedEmail, setSelectedEmail] = useState(null);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const accountsPerPage = 16; // 每頁顯示12個帳戶
  const [searchQuery, setSearchQuery] = useState(""); // 搜尋輸入框的值
	
	// 在組件頂部定義 state
	const [sortedAccounts, setSortedAccounts] = useState([]);

    
    const darkMode = JSON.parse(localStorage.getItem("darkMode")) ?? true;
	
    // 計算分頁
	const indexOfLastAccount = currentPage * accountsPerPage;
	const indexOfFirstAccount = indexOfLastAccount - accountsPerPage;
	const currentAccounts = sortedAccounts.slice(indexOfFirstAccount, indexOfLastAccount);
	const totalPages = Math.ceil(sortedAccounts.length / accountsPerPage);
	
	// 1. 增加確認模態框的狀態
	const [showConfirmModal, setShowConfirmModal] = useState(false);

	// 2. 修改原本的創建按鈕事件處理
	const handleCreateButtonClick = () => {
		if (!email.trim()) {
			setError('請輸入郵件地址');
			return;
		}
		setError('');
		setShowConfirmModal(true);
	};



    // 生成分頁按鈕數組
    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
    }
	

useEffect(() => {
    // 初始加載
    fetchAccounts();

    // 設置 5 秒定時器
    const timer = setInterval(() => {
        fetchAccounts();
        // 只在有選中帳戶時更新郵件
        if (selectedAccount) {
            handleViewEmails(selectedAccount);
        }
    }, 5000);

    return () => clearInterval(timer);
}, []); // 移除 selectedAccount 依賴



// 修改 fetchAccounts，保持選中帳戶的位置
const fetchAccounts = async () => {
    try {
        const response = await fetch('https://mailcreation.mcvanuatu.com/list-accounts');
        const data = await response.json();
        
        if (data.accounts) {
            // 保存當前排序狀態
            const currentOrder = sortedAccounts.map(acc => acc.email);
            
            // 更新數據但保持選中帳戶的位置
            let newAccounts = [...data.accounts];
            
            // 如果有選中的帳戶，確保它保持在原來的位置
            if (selectedAccount) {
                const selectedIndex = currentOrder.indexOf(selectedAccount);
                if (selectedIndex !== -1) {
                    // 找到新數據中的選中帳戶
                    const selectedData = newAccounts.find(acc => acc.email === selectedAccount);
                    if (selectedData) {
                        // 從新數據中移除
                        newAccounts = newAccounts.filter(acc => acc.email !== selectedAccount);
                        // 將選中帳戶插入到原來的位置
                        newAccounts.splice(selectedIndex, 0, selectedData);
                    }
                }
            }
            
            // 只對非選中帳戶進行排序
            const otherAccounts = newAccounts
                .filter(acc => acc.email !== selectedAccount)
                .sort((a, b) => {
                    if (!a.last_logon_time) return 1;
                    if (!b.last_logon_time) return -1;
                    return new Date(b.last_logon_time) - new Date(a.last_logon_time);
                });
                
            // 如果有選中帳戶，保持其位置
            if (selectedAccount) {
                const selectedData = newAccounts.find(acc => acc.email === selectedAccount);
                if (selectedData) {
                    const selectedIndex = currentOrder.indexOf(selectedAccount);
                    otherAccounts.splice(selectedIndex, 0, selectedData);
                }
            }
            
            setSortedAccounts(otherAccounts);
        }
    } catch (err) {
        setError('獲取帳戶列表失敗');
        console.error('Error fetching accounts:', err);
    }
};



const handleCreateAccount = async () => {
    const fullEmail = `${email}@querymail.net`;
    try {
        const response = await fetch('https://mailcreation.mcvanuatu.com/create-account', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email: fullEmail })
        });
        const data = await response.json();
        if (response.ok) {
            setSuccess('帳戶創建成功！');
            setEmail('');
            fetchAccounts();
            setShowConfirmModal(false);  // 關閉確認框
        } else {
            setError(data.error || '創建帳戶失敗');
        }
    } catch (err) {
        setError('創建帳戶失敗');
    }
};

const handleViewEmails = async (emailAddress) => {
    try {
        const response = await fetch('https://mailcreation.mcvanuatu.com/login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Set-Cookie': 'SameSite=Strict'
            },
            body: JSON.stringify({ email: emailAddress }),
            credentials: 'omit'
        });
        const data = await response.json();
        if (response.ok) {
            const decodedEmails = data.emails.map(email => ({
                ...email,
                body: decodeEmailBody(email.body)
            }));
            
            const sortedEmails = decodedEmails.sort((a, b) => 
                new Date(b.date) - new Date(a.date)
            );
            
            setMessages(sortedEmails);
            setSelectedAccount(emailAddress);
            setError('');
        } else {
            setError('獲取郵件失敗');
            setMessages([]);
        }
    } catch (err) {
        console.error('API錯誤:', err);
        setError('獲取郵件失敗');
        setMessages([]);
    }
};




const decodeEmailBody = (body) => {
    if (!body) return '(無內容)';
    
    try {
        // 找到完整的 URL
        const startIndex = body.indexOf("( https://foodpanda");
        const endIndex = body.indexOf(" )", startIndex);
        
        if (startIndex >= 0 && endIndex >= 0) {
            // 取得完整的文字和URL
            const fullMatch = body.substring(startIndex, endIndex + 2);
            const url = body.substring(startIndex + 2, endIndex).trim();
            
            // 替換為超連結
            const result = body.replace(
                fullMatch, 
				 `( <a href="${url}" target="_blank" style="color: ${
					darkMode ? '#ffc387' : '#fcaa58'
				}; text-decoration: underline; font-weight: bold;">點擊開外掛</a> )`
            );
            
            return result;
        }
        
        return body;
    } catch (err) {
        console.error('郵件解碼錯誤:', err);
        return body || '(無內容)';
    }
};


    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
    };
    
    return (
            <motion.div 
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="container w-full max-w-full"
            >
				{error && (
					<div className={`mb-4 p-3 rounded ${
						darkMode 
							? "bg-red-900/20 text-red-300" 
							: "bg-red-100 text-red-700"
					}`}>
						{error}
					</div>
				)}

				{success && (
					<div className={`mb-4 p-3 rounded ${
						darkMode 
							? "bg-green-900/20 text-green-300" 
							: "bg-green-100 text-green-700"
					}`}>
						{success}
					</div>
				)}


                <div className="space-y-6">
					{/* 創建帳戶部分 */}
					<div className={`p-5 rounded-lg shadow-md w-fit ${darkMode ? "bg-[#1E1E1E]" : "bg-white"}`}>
						<div className="text-xl font-semibold mb-3">創建郵件帳戶</div>
						<div className="flex flex-wrap gap-2">
							<div className="flex w-fit">
								<input
									type="text"
									value={email}
									onChange={(e) => setEmail(e.target.value)}
									placeholder="輸入用戶名"
									className={`w-32 px-3 py-2 rounded-l z-10 ${
										darkMode 
											? "bg-[#2C2C2C] text-[#F5F5F5] border-[#404040]" 
											: "bg-[#F5F5F5] text-[#121212] border-[#E0E0E0]"
									}`}
								/>
								<span className={`px-3 py-2 rounded-r font-semibold ${
										darkMode 
											? "bg-[#2C2C2C] text-[#F5F5F5] border-[#404040]" 
											: "bg-[#F5F5F5] text-[#121212] border-[#E0E0E0]"
								}`}>@querymail.net</span>
							</div>
								<button 
									onClick={handleCreateButtonClick}
									className={`px-4 py-2 rounded font-bold transition-colors ${
										darkMode 
											? "bg-[#404040] text-[#F5F5F5] hover:bg-[#2C2C2C]" 
											: "bg-[#2C2C2C] text-[#F5F5F5] hover:bg-[#404040]"
									}`}
								>
									創建帳戶
								</button>
						</div>
					</div>

{/* 搜尋功能 */}
<div
  className={`p-5 rounded-lg shadow-md ${darkMode ? "bg-[#1E1E1E]" : "bg-white"}`}
>
  <div className="text-xl font-semibold mb-3">搜尋帳戶</div>
  <div className="flex gap-2">
    <input
      type="text"
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
      placeholder="輸入郵件地址"
      className={`flex-grow px-3 py-2 rounded ${
        darkMode
          ? "bg-[#2C2C2C] text-[#F5F5F5] border-[#404040]"
          : "bg-[#F5F5F5] text-[#121212] border-[#E0E0E0]"
      }`}
    />
    <button
      onClick={() => handleViewEmails(searchQuery)}
      className={`px-4 py-2 rounded font-bold transition-colors ${
        darkMode
          ? "bg-[#404040] text-[#F5F5F5] hover:bg-[#2C2C2C]"
          : "bg-[#2C2C2C] text-[#F5F5F5] hover:bg-[#404040]"
      }`}
    >
      搜尋
    </button>
  </div>
</div>
                    {/* 帳戶列表和分頁 */}
                    <div className={`p-4 rounded-lg shadow-md ${darkMode ? "bg-[#1E1E1E]" : "bg-white"}`}>
                        <div className="!text-xl font-semibold mb-3">郵件帳戶列表</div>
					<div className="flex flex-wrap gap-2 !w-full">
						{currentAccounts.map((account, index) => (
							<button 
								key={account.email}  // 改用唯一的 email 作為 key
								onClick={() => handleViewEmails(account.email)}
								className={`flex items-center gap-1 px-2 py-1 rounded text-sm transition-colors hover:opacity-80 ${
									selectedAccount === account.email
										? darkMode 
											? "bg-[#404040] text-[#F5F5F5]" 
											: "bg-[#2C2C2C] text-[#F5F5F5]"
										: darkMode 
											? "bg-[#2C2C2C] text-[#F5F5F5]" 
											: "bg-[#F5F5F5] text-[#121212]"
								}`}
							>
								<span>{account.email.split('@')[0]}</span>
							</button>
						))}

					</div>
                        
                        {/* 分頁控制 */}
                        {totalPages > 1 && (
                            <div className="flex justify-center gap-2 mt-4">
                                <button
                                    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                    disabled={currentPage === 1}
                                    className={`px-3 py-1 rounded ${
                                        darkMode 
                                            ? "bg-[#404040] text-[#F5F5F5] disabled:opacity-50" 
                                            : "bg-[#2C2C2C] text-[#F5F5F5] disabled:opacity-50"
                                    }`}
                                >
                                    上一頁
                                </button>
                                <span className={`px-3 py-1 ${
                                    darkMode ? "text-[#F5F5F5]" : "text-[#121212]"
                                }`}>
                                    {currentPage} / {totalPages}
                                </span>
                                <button
                                    onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                    disabled={currentPage === totalPages}
                                    className={`px-3 py-1 rounded ${
                                        darkMode 
                                            ? "bg-[#404040] text-[#F5F5F5] disabled:opacity-50" 
                                            : "bg-[#2C2C2C] text-[#F5F5F5] disabled:opacity-50"
                                    }`}
                                >
                                    下一頁
                                </button>
                            </div>
                        )}
                    </div>

                    {/* 郵件內容區域 */}
                    {selectedAccount && (
                        <div className={`p-4 rounded-lg shadow-md ${darkMode ? "bg-[#1E1E1E]" : "bg-white"}`}>
                            <div className="flex items-center justify-between mb-4">
                                <div className="!text-xl font-semibold">
                                    {selectedAccount} 的收件箱
                                </div>
                            </div>

                            <div className="flex flex-col lg:flex-row gap-4 h-[calc(100vh-150px)] w-full">
                                {/* 郵件列表 */}
								<div className={`w-full lg:w-1/5 overflow-y-auto rounded-lg border ${
									darkMode ? "border-[#404040]" : "border-[#E0E0E0]"
								}`}>
									{messages.length > 0 ? messages.map((msg, index) => (
										<button
											key={index}
											onClick={() => setSelectedEmail(index)}
											className={`w-full text-left p-3 border-b last:border-b-0 ${
												selectedEmail === index
													? darkMode 
														? "bg-[#2C2C2C] text-[#F5F5F5]"
														: "bg-[#F5F5F5] text-[#121212]"
													: darkMode
														? "text-[#F5F5F5] hover:bg-[#2C2C2C]"
														: "text-[#121212] hover:bg-[#F5F5F5]"
											}`}
										>
											<div className="flex justify-between items-center">
												<div className="font-medium truncate max-w-[70%]">
													{msg.subject || '(無主題)'}
												</div>
												<div className="text-xs">
													{new Date(msg.date).toLocaleString('zh-HK', {
														month: '2-digit',
														day: '2-digit',
														hour: '2-digit',
														minute: '2-digit'
													})}
												</div>
											</div>
										</button>
									)) : (
										<div className="p-4 text-center">
											沒有郵件
										</div>
									)}
								</div>


                                {/* 郵件內容 */}
                                <div className={`flex-1 overflow-y-auto rounded-lg border ${
                                    darkMode ? "border-[#404040]" : "border-[#E0E0E0]"
                                }`}>
                                    {selectedEmail !== null && messages[selectedEmail] ? (
                                        <div className="p-4 space-y-3">
                                            <div className="grid grid-cols-3 sm:grid-cols-12 gap-2 text-sm">
                                                <div className="col-span-1 sm:col-span-2 font-medium">寄件人：</div>
                                                <div className="col-span-2 sm:col-span-10">
                                                    {messages[selectedEmail].from}
                                                </div>
                                            </div>
                                            <div className="grid grid-cols-3 sm:grid-cols-12 gap-2 text-sm">
                                                <div className="col-span-1 sm:col-span-2 font-medium">日期：</div>
                                                <div className="col-span-2 sm:col-span-10">
                                                    {new Date(messages[selectedEmail].date).toLocaleString('zh-HK')}
                                                </div>
                                            </div>
                                            <div className="grid grid-cols-3 sm:grid-cols-12 gap-2 text-sm">
                                                <div className="col-span-1 sm:col-span-2 font-medium">主旨：</div>
                                                <div className="col-span-2 sm:col-span-10">
                                                    {messages[selectedEmail].subject || '(無主題)'}
                                                </div>
                                            </div>
                                            
                                            <div className={`mt-4 rounded ${
                                                darkMode ? "bg-[#1E1E1E]" : "bg-[#F5F5F5]"
                                            }`}>
                                                <div 
                                                    dangerouslySetInnerHTML={{ 
                                                        __html: decodeEmailBody(messages[selectedEmail].body)
                                                    }}
                                                    className="w-full break-words"
                                                />
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="p-8 text-center">
                                            選擇郵件以查看內容
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
					{/* 5. 添加確認模態框 */}
{showConfirmModal && (
    <div className="fixed top-0 left-0 right-0 bottom-0 w-screen h-screen flex items-center justify-center bg-black bg-opacity-50 z-50 [margin:0!important]">
        <div className={`relative w-80 rounded-lg shadow-lg ${
            darkMode ? "bg-[#1E1E1E]" : "bg-white"
        }`}>
            {/* 確認訊息 */}
            <div className="p-5 text-left">
                <h3 className="text-lg font-semibold mb-2">確認創建帳戶</h3>
                <p>{email}@querymail.net</p>
            </div>
            
            {/* 按鈕 */}
            <div className="flex justify-end gap-2 p-4 border-opacity-20 border-current">
                <button 
                    onClick={() => setShowConfirmModal(false)}
                    className={`px-4 py-2 rounded transition-colors ${
                        darkMode 
                            ? "bg-[#2C2C2C] text-[#F5F5F5] hover:bg-[#804d29]" 
                            : "bg-[#F5F5F5] text-[#121212] hover:bg-[#E0E0E0]"
                    }`}
                >
                    取消
                </button>
                <button 
                    onClick={handleCreateAccount}
                    className={`px-4 py-2 rounded font-bold transition-colors ${
                        darkMode 
                            ? "bg-[#404040] text-[#F5F5F5] hover:bg-[#804d29]" 
                            : "bg-[#2C2C2C] text-[#F5F5F5] hover:bg-[#804d29]"
                    }`}
                >
                    確定
                </button>
            </div>
        </div>
    </div>
)}
                </div>
            </motion.div>
			
			
    );
}

export default Email;